<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="!isNew ? item.email : ''">
      <v-form ref="form" v-model="validForm" autocomplete="off" role="presentation">
        <v-container grid-list-md>
          <v-layout wrap>


            <v-flex xs12 sm6 md6>
              <v-text-field
                :readonly="readonly"
                label="Name"
                v-model="item.name"
                :rules="validators.company_user.name"
              ></v-text-field>
            </v-flex>


             <v-flex xs12 sm6 md6>
              <v-text-field
                :readonly="readonly"
                label="Email"
                v-model="item.email"
                :rules="validators.email"
              ></v-text-field>
            </v-flex>


            <v-flex xs12 sm12 md12>
               <v-combobox
                multiple
                v-model="item.countries"
                label="Countries"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                @keydown.space.prevent>
              </v-combobox>
            </v-flex>


             <v-flex xs12 sm12 md12>
               <v-autocomplete
                md4
                clearable
                :search-input.sync="companySearchString"
                v-model="item.company_id"
                :items="companies"
                color="green"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Company"
                placeholder="Choose from Companies..."
                prepend-icon="mdi-database-search"
                :loading="loadingCompanies"
                :rules="validators.company_user.company"
                @input="selectedCompany"
              >
                <template slot="item" slot-scope="{ item }" >
                  <v-list-tile-content>
                      <v-list-tile-title>{{item.name}}</v-list-tile-title>
                    </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>


            <v-flex xs12 sm12 md12>
               <v-autocomplete
                multiple
                v-model="item.protocols"
                :items="companyProtocols"
                item-value="protocol.id"
                item-text="protocol.name"
                label="Protocols"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                :disabled="!item.company_id"
                @keydown.space.prevent>
              </v-autocomplete>
            </v-flex>

         
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!validForm"
          @click="save()"
          v-if="$can('upsert', 'company_user')"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail } from "@/api/company_user";
import { getList as getCompanies } from "@/api/company";
import { getList as getCompaniesProtocols } from "@/api/company_has_protocol";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    item : {},
    value: false
  },
  data() {
    return {
      validForm: true,
      validators,
      loadingCompanies: false,
      companySearchString: '',
      companies: [],
      companyProtocols: [],
      savedCompanyId: null
    };
  },
  mounted() {
    this.savedCompanyId = this.item.company_id;
    if (!this.isNew) {
      this.companies.push(this.item.company);
    }
  },
  watch: {
    value() {
      this.savedCompanyId = this.item.company_id;
      if (this.isNew) {
        this.companyProtocols = [];
        this.$refs.form.reset();
      } else {
        this.companies.push(this.item.company);
        getCompaniesProtocols({company_id: this.item.company.id}, {rowsPerPage: null, sortBy:'protocol.name'}).then( data => {
          this.companyProtocols = data.data;
        })
      }
    },
    companySearchString(val, oldVal) {
        if (!val) {
          this.companies = [];
          return;
        }
        this.loadingCompanies = true
        getCompanies({'name': val + '%'}, {rowsPerPage: null}).then((data) => {
          this.companies = data.data;
          this.loadingCompanies = false;
        })
    },
    'item.company_id'(newVal) {
      if (newVal !== this.savedCompanyId) {
        this.item.protocols = [];
      }
    },
  },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New Company User" : (this.readonly ? 'Company User details' : "Edit Company User" );
    },
    readonly() {
      return !this.$can('upsert', 'company_user');
    }
  },
  methods: {
    getData() {
      return getDetail(this.item.id, this.projectId).then(data => {
        const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
      });
    },
    close() {
       this.$emit('input', false)
    },
    selectedCompany(company_id) {
      if (company_id) {
        getCompaniesProtocols({company_id}, {rowsPerPage: null, sortBy:'protocol.name'}).then( data => {
          this.companyProtocols = data.data;
        })
      }
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          const message = this.isNew ? "Company user created correctly" : 
            "Company user updated correctly";
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          this.$root.$emit('updateCompanyUsers', newItem);
        })
        .catch(e => {
          const mex = this.isNew ? "An Error occurred during the Company user create. " : 
            "An Error occurred during the Company user update. ";
          this.$store.dispatch("app/openSnackbar", {
            message: mex + e.response.data.message,
            color: "error"
          });
        });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
